import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  VStack,
  Icon,
  Box,
  Heading,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { FiUser, FiSettings } from "react-icons/fi";

interface WelcomeModalProps {
  isOpen: boolean;
  onStartExploring: () => Promise<void>;
}

export const WelcomeModal = ({
  isOpen,
  onStartExploring,
}: WelcomeModalProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleStartExploring = async () => {
    setIsLoading(true);
    try {
      await onStartExploring();
    } catch (error) {
      console.error("Error starting exploration:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {}} // Prevent closing without action
      closeOnOverlayClick={false}
      closeOnEsc={false}
      isCentered
      size="md"
    >
      <ModalContent mx={4}>
        <ModalHeader pb={2}>
          <VStack spacing={3}>
            <Box
              p={4}
              bg="brand.50"
              borderRadius="full"
              border="2px solid"
              borderColor="brand.200"
            >
              <Icon
                as={FiUser as React.ElementType}
                boxSize={8}
                color="brand.500"
              />
            </Box>
            <Heading size="lg" textAlign="center" color="gray.800">
              Welcome to Agentic Platform!
            </Heading>
          </VStack>
        </ModalHeader>

        <ModalBody py={6}>
          <VStack spacing={4} textAlign="center">
            <Text fontSize="md" color="gray.600" lineHeight="1.6">
              To get started with our agentic platform, we need to set up your
              user permissions. This will give you access to all the tools and
              features available to explore.
            </Text>

            <Box
              p={4}
              bg="blue.50"
              borderRadius="lg"
              border="1px solid"
              borderColor="blue.200"
              w="100%"
            >
              <VStack spacing={2}>
                <Icon
                  as={FiSettings as React.ElementType}
                  boxSize={5}
                  color="blue.500"
                />
                <Text fontSize="sm" color="blue.700" fontWeight="medium">
                  What happens next?
                </Text>
                <Text fontSize="xs" color="blue.600" textAlign="center">
                  We'll assign you the necessary permissions to access
                  applications, create visualizations, and collaborate with your
                  team.
                </Text>
              </VStack>
            </Box>
          </VStack>
        </ModalBody>

        <ModalFooter pt={2}>
          <Button
            colorScheme="brand"
            size="lg"
            width="100%"
            onClick={handleStartExploring}
            isLoading={isLoading}
            loadingText="Setting up your account..."
          >
            Start Exploring
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
